/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to the top of the page when the route changes.
 * This ensures users always see the top of the new page when navigating.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 *
 * Scrolls the window to the top whenever the location (route) changes.
 * Skips scroll for /insights so the Insights nav click does not trigger auto-scroll.
 */
export function ScrollToTop(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    const skip = pathname === '/insights' || pathname.startsWith('/insights/');
    if (skip) {
      return;
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname]);

  return null;
}

